import type { IdentityInfoSchemaType } from '@/types/portal-api.generated'

type IdentityScopes = IdentityInfoSchemaType['scopes']

let cachedScopes: IdentityScopes | null = null
let inFlightScopes: Promise<IdentityScopes> | null = null

export function getCachedTrustedIdentityScopes(): IdentityScopes | null {
  return cachedScopes
}

export function setCachedTrustedIdentityScopesFromIdentity(
  identity: IdentityInfoSchemaType,
): IdentityScopes {
  cachedScopes = identity.scopes
  return cachedScopes
}

export async function fetchTrustedIdentityScopes(
  loadIdentity: () => Promise<IdentityInfoSchemaType>,
): Promise<IdentityScopes> {
  if (cachedScopes) {
    return cachedScopes
  }

  if (inFlightScopes) {
    return inFlightScopes
  }

  inFlightScopes = loadIdentity()
    .then((identity) => {
      cachedScopes = identity.scopes
      return cachedScopes
    })
    .finally(() => {
      inFlightScopes = null
    })

  return inFlightScopes
}

export function restoreCachedTrustedIdentityScopes(scopes: IdentityScopes | null): void {
  cachedScopes = scopes
  inFlightScopes = null
}

export function clearTrustedIdentityScopesCache(): void {
  cachedScopes = null
  inFlightScopes = null
}
